import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import Navigation from '../components/Navigation';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export default function MoodTimeline({ user, onLogout }) {
  const [moods, setMoods] = useState([]);

  useEffect(() => {
    fetchMoods();
  }, []);

  const fetchMoods = async () => {
    try {
      const res = await axios.get(`${API}/moods?limit=50`);
      setMoods(res.data);
    } catch (error) {
      console.error('Failed to fetch moods', error);
    }
  };

  const chartData = moods.map(mood => ({
    time: new Date(mood.timestamp).toLocaleDateString(),
    intensity: mood.intensity,
    name: mood.mood_name
  })).reverse();

  return (
    <div className="min-h-screen pb-24" style={{ backgroundColor: '#FAF9F6' }}>
      <div className="container mx-auto px-6 py-8 max-w-6xl">
        <h1 className="text-4xl font-bold mb-8" style={{ fontFamily: 'Fredoka', color: '#073B4C' }}>
          Your Mood Timeline
        </h1>

        {moods.length > 0 ? (
          <>
            <div className="glass-card p-6 mb-6" data-testid="mood-chart">
              <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Fredoka' }}>Mood Intensity Over Time</h3>
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={chartData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.1)" />
                  <XAxis dataKey="time" stroke="#073B4C" />
                  <YAxis stroke="#073B4C" domain={[0, 10]} />
                  <Tooltip />
                  <Line type="monotone" dataKey="intensity" stroke="#FFD166" strokeWidth={3} dot={{ fill: '#FFD166', r: 5 }} />
                </LineChart>
              </ResponsiveContainer>
            </div>

            <div className="glass-card p-6" data-testid="mood-list">
              <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Fredoka' }}>All Entries</h3>
              <div className="space-y-3">
                {moods.map((mood) => (
                  <div key={mood.id} className="p-4 rounded-xl bg-white/50 hover:bg-white/70 transition-all">
                    <div className="flex items-start justify-between">
                      <div className="flex items-start gap-4">
                        <span className="text-4xl">{mood.mood_emoji}</span>
                        <div>
                          <p className="font-bold text-lg">{mood.mood_name}</p>
                          <p className="text-sm" style={{ opacity: 0.7 }}>
                            {new Date(mood.timestamp).toLocaleString()}
                          </p>
                          {mood.reason && (
                            <p className="mt-2 text-sm">{mood.reason}</p>
                          )}
                          {mood.tags && mood.tags.length > 0 && (
                            <div className="flex gap-2 mt-2">
                              {mood.tags.map((tag, idx) => (
                                <span key={idx} className="text-xs px-2 py-1 rounded-full" style={{ backgroundColor: '#FFD166', color: '#073B4C' }}>
                                  {tag}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold" style={{ color: '#EF476F' }}>{mood.intensity}/10</p>
                        <p className="text-xs" style={{ opacity: 0.7 }}>Intensity</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : (
          <div className="glass-card p-12 text-center">
            <p className="text-xl" style={{ color: '#073B4C', opacity: 0.7 }}>No mood entries yet. Start tracking!</p>
          </div>
        )}
      </div>

      <Navigation active="timeline" />
    </div>
  );
}